const DiscountWidget = class extends HTMLElement {
  connectedCallback() {
    let cartUpdated = false;

    this.initAccordions();
    this.initDrawer();

    document.addEventListener('theme:cart:change', async () => {
      if (!cartUpdated) { // prevent blinking when cart is fetched first time after page load
        cartUpdated = true;
        return;
      }

      const response = await fetch(`${window.theme.routes.root_url}?section_id=api-discount-widget`);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html').querySelector('discount-widget').innerHTML;

      this.innerHTML = html;

      this.initAccordions = this.initAccordions.bind(this);
      this.initDrawer = this.initDrawer.bind(this);

      this.initAccordions();
      this.initDrawer();
    });
  }

  initAccordions() {
    const accordions = this.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const button = accordion.querySelector('[data-button]');
      const icons = button.querySelectorAll('.icon');
      const content = accordion.querySelector('[data-content]');

      button.addEventListener('click', () => {
        icons.forEach((icon) => {
          icon.classList.toggle('hidden', !icon.classList.contains('hidden'));
        });

        content.hidden = !content.hidden;
        button.ariaExpanded = `${!content.hidden}`;
      });
    });
  }

  initDrawer() {
    const drawer = this.querySelector('[data-drawer]');
    const drawerUnderlay = this.querySelector('[data-drawer-underlay]');
    const drawerButton = this.querySelector('[data-drawer-button]');
    const drawerClose = this.querySelector('[data-drawer-close]');

    document.body.appendChild(drawer);

    const visibleClass = 'drawer--visible';

    const open = () => {
      drawer.classList.add(visibleClass);
    };

    const close = () => {
      drawer.classList.remove(visibleClass);
    };

    drawerButton.addEventListener('click', open);
    drawerClose.addEventListener('click', close);
    drawerUnderlay.addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
      }
    });
  }
}

if (!customElements.get('discount-widget')) {
  customElements.define('discount-widget', DiscountWidget);
}